/* global google */

const googleMapsHelper = {
  directionsUrl({ street, city, state }) {
    const address = [street, city, state].join(' ');

    return encodeURI(
      `https://www.google.com/maps/dir/?api=1&destination=${address}`,
    );
  },

  coordsToPostcode({ longitude: lng, latitude: lat }) {
    return new Promise((resolve, reject) => {
      const geocoder = new google.maps.Geocoder();

      geocoder.geocode({ location: { lat, lng } }, (results, status) => {
        if (status !== 'OK') { reject(); return; }

        const addressComponents = results.reduce(
          (acc, cur) => acc.concat(cur.address_components), [],
        );

        const postcodeComponent = addressComponents.find(
          (address) => (address.types[0] === 'postal_code'),
        );

        if (postcodeComponent && postcodeComponent.long_name) {
          resolve(postcodeComponent.long_name);
        } else {
          reject();
        }
      }, reject);
    });
  },

  getCurrentPostcode(onSuccess, onError) {
    if (!navigator.geolocation) { onError(); return; }

    navigator.geolocation.getCurrentPosition((position) => {
      this.coordsToPostcode(position.coords).then(onSuccess, onError);
    }, () => {
      onError();
    }, {
      timeout: 10000,
      maximumAge: 60000,
    });
  },
};

export default googleMapsHelper;
